import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import HomePage from "./HomePage";

import Footer from "./Footer";

const About = () => {
  const [stylingOnClickFeatures, setstylingOnClickFeatures] = useState();
  const history = useHistory();

  useEffect(() => {
    setstylingOnClickFeatures("MediumBlue");
  }, []);

  const handleStartTrial = () => {
    history.push("/signup");
  };

  const handleContactSales = () => {
    history.push("/ContactPage");
  };
  return (
    <div>
      <HomePage stylingOnClickFeatures={stylingOnClickFeatures} />

      {/* Modern Hero Section */}
      <div
        style={{
          background:
            "linear-gradient(135deg, #4299e1 0%, #667eea 50%, #764ba2 100%)",
          padding: "4rem 2rem",
          color: "white",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
          }}
        ></div>
        <div
          style={{
            position: "relative",
            zIndex: 1,
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "800",
              margin: "0 0 1rem 0",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
              fontFamily: "'Inter', sans-serif",
              letterSpacing: "-0.02em",
            }}
          >
            📊 About FilingStack Accounting
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              opacity: 0.9,
              margin: "0",
              fontWeight: "400",
            }}
          >
            Discover why businesses trust FilingStack for their accounting needs
          </p>
        </div>
      </div>

      {/* Main Content Container */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "3rem 2rem",
          backgroundColor: "#f8fafc",
          minHeight: "100vh",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {/* Introduction Section */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            padding: "3rem",
            marginBottom: "3rem",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e2e8f0",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#4299e1",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "2rem",
              }}
            >
              🚀
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#2d3748",
                background: "linear-gradient(135deg, #4299e1, #667eea)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Frequently Asked Questions
            </h2>
          </div>
          <p
            style={{
              fontSize: "1.2rem",
              color: "#718096",
              lineHeight: "1.6",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Everything you need to know about FilingStack Accounting - your
            complete business solution
          </p>
        </div>

        {/* FAQ Grid */}
        <div
          style={{
            display: "grid",
            gap: "2rem",
            gridTemplateColumns: "1fr",
          }}
        >
          {/* FAQ Item 1 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#4299e1";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#4299e1",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                🏢
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  What is FilingStack Accounting?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack Accounting is an online accounting software
                  application, accessible through a browser. It provides
                  comprehensive financial management tools for businesses of all
                  sizes.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 2 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#48bb78";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#48bb78",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                ⚙️
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  What can you use FilingStack Accounting for?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack Accounting can be used to store financial records
                  and generate financial accounting reports, including invoices,
                  VAT reports, ledgers, trial balances and financial statements.
                  FilingStack offers advanced software tools that help convert
                  PDF bank statements to CSV.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 3 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#805ad5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#805ad5",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                💎
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  Why FilingStack Accounting?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack Accounting integrates your accounting records with
                  financial statement generation, allowing for less complexity,
                  high level efficiency, and a super user experience. Plus, you
                  can generate beautiful invoices and accurate VAT returns, all
                  from 1 application, with affordable pricing.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 4 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#ed8936";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#ed8936",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                🛠️
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  Does FilingStack Accounting offer support to clients?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  Yes, we are available to assist. Visit the{" "}
                  <a
                    href="/ContactPage"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#4299e1",
                      textDecoration: "none",
                      fontWeight: "600",
                      borderBottom: "2px solid #4299e1",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = "#3182ce";
                      e.target.style.borderBottomColor = "#3182ce";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#4299e1";
                      e.target.style.borderBottomColor = "#4299e1";
                    }}
                  >
                    Contact Us
                  </a>{" "}
                  page for more details.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 5 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#38b2ac";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#38b2ac",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                💰
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  How does FilingStack Accounting pricing work?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack offers affordable, month-to-month billing options,
                  which bills clients monthly. FilingStack does not offer
                  contracts and clients can opt out and cancel their
                  subscription at any time.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 6 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e53e3e";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#e53e3e",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                ❌
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  How do I cancel my subscription?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  Clients can cancel their subscription on the{" "}
                  <a
                    href="/Payment"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#e53e3e",
                      textDecoration: "none",
                      fontWeight: "600",
                      borderBottom: "2px solid #e53e3e",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = "#c53030";
                      e.target.style.borderBottomColor = "#c53030";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#e53e3e";
                      e.target.style.borderBottomColor = "#e53e3e";
                    }}
                  >
                    payments page
                  </a>{" "}
                  (clients must be logged in)
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 7 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#48bb78";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#48bb78",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                🆓
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  Does FilingStack Accounting offer a free trial period?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  Yes, all new clients get free access to a Demo company to
                  review the FilingStack product. Signing up is free and gives
                  you full access to explore our features.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 8 */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#4299e1";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "#4299e1",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                }}
              >
                🌍
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  Is FilingStack Accounting country specific?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "#4a5568",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack Accounting welcomes international clients. The
                  Payroll and VAT reports are currently customized for South
                  Africa. All billing is in South African Rands.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Item 9 - Team Section */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "2.5rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e2e8f0",
              transition: "all 0.3s ease",
              cursor: "pointer",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 20px 25px -5px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  flexShrink: 0,
                  backdropFilter: "blur(10px)",
                }}
              >
                👨‍💼
              </div>
              <div>
                <h3
                  style={{
                    margin: "0 0 1rem 0",
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "white",
                  }}
                >
                  Who is FilingStack managed by?
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "1rem",
                    color: "rgba(255, 255, 255, 0.9)",
                    lineHeight: "1.6",
                  }}
                >
                  FilingStack Accounting software was started by{" "}
                  <a
                    href="https://www.linkedin.com/in/zaahid-p-339435161/"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#ffd89b",
                      textDecoration: "none",
                      fontWeight: "600",
                      borderBottom: "2px solid #ffd89b",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = "#ffed4e";
                      e.target.style.borderBottomColor = "#ffed4e";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#ffd89b";
                      e.target.style.borderBottomColor = "#ffd89b";
                    }}
                  >
                    Zaahid Patel
                  </a>
                  . Zaahid serves as a director of FilingStack. Zaahid is a
                  graduate of{" "}
                  <a
                    href="https://www.mancosa.co.za/"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#ffd89b",
                      textDecoration: "none",
                      fontWeight: "600",
                      borderBottom: "2px solid #ffd89b",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = "#ffed4e";
                      e.target.style.borderBottomColor = "#ffed4e";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#ffd89b";
                      e.target.style.borderBottomColor = "#ffd89b";
                    }}
                  >
                    Mancosa
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action Section */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            padding: "4rem 3rem",
            marginTop: "3rem",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e2e8f0",
            textAlign: "center",
            background: "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
          }}
        >
          <div
            style={{
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#4299e1",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "2.5rem",
                margin: "0 auto 2rem auto",
                boxShadow: "0 10px 25px rgba(66, 153, 225, 0.3)",
              }}
            >
              🎯
            </div>
            <h2
              style={{
                margin: "0 0 1.5rem 0",
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#2d3748",
                lineHeight: "1.2",
              }}
            >
              Ready to Transform Your Business?
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#718096",
                lineHeight: "1.6",
                marginBottom: "2rem",
              }}
            >
              Join businesses who trust FilingStack for their accounting needs.
              Start your free trial today and experience the difference.
            </p>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                style={{
                  padding: "1rem 2rem",
                  borderRadius: "12px",
                  border: "none",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  backgroundColor: "#4299e1",
                  color: "white",
                  boxShadow: "0 4px 12px rgba(66, 153, 225, 0.3)",
                }}
                onClick={handleStartTrial}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#3182ce";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 20px rgba(66, 153, 225, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#4299e1";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 12px rgba(66, 153, 225, 0.3)";
                }}
              >
                🚀 Start Free Trial
              </button>
              <button
                style={{
                  padding: "1rem 2rem",
                  borderRadius: "12px",
                  border: "2px solid #4299e1",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  backgroundColor: "transparent",
                  color: "#4299e1",
                }}
                onClick={handleContactSales}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#4299e1";
                  e.target.style.color = "white";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 20px rgba(66, 153, 225, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#4299e1";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                💬 Contact Sales
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
